import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest, HttpErrorResponse } from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { BsModalService, ModalBackdropComponent } from 'ngx-bootstrap/modal'
import { RulesEngineModalComponent } from './upload-csv-modal/rules-engine-modal.component'

@Injectable()
export class RulesEngineInterceptor implements HttpInterceptor {
   constructor(private modalService: BsModalService) {}

   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(req).pipe(
         catchError((error: HttpErrorResponse) => {
            console.log('intercepted error', error)
            if (error.status === 422) {
               error.error.text().then((res) => {
                  var message = JSON.parse(res).error.message
                  this.modalService.show(RulesEngineModalComponent, {
                     initialState: {
                        title: 'Rule Violation',
                        message,
                        onConfirm: () => {
                           // Clone the original request and add a custom header
                           const overrideReq = req.clone({
                              headers: req.headers.set('RulesEngine', 'Override'),
                           })

                           // Re-run the HTTP call
                           next.handle(overrideReq).subscribe({
                              next: (resp) => {
                                 console.log('API retried successfully', resp)
                              },
                              error: (err) => {
                                 console.error('Retry failed', err)
                              },
                           })
                        },
                        onCancel: () => {
                           /* do nothing */
                        },
                     },
                  })
               })
            }
            return throwError(() => error)
         })
      )
   }
}
